<template>
	<div>
		<v-tabs
			color="#233b5d"
			v-model="selectedTab"
			fixed-tabs
			slider-color="yellow"
		>
			<v-tab
				v-for="(tab, index) in tabs"
				:key="index"
				class="white--text"
				:href="`#${tab}`"
			>
				{{ tab }}
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="selectedTab">
			<v-tab-item :value="tabs[0]">
				<v-card
					color="#EDF0F7"
					class="bg"
					v-infinite-scroll="fetchMatchHistory"
					infinite-scroll-disabled="disableMatchHistoryFetching"
					infinite-scroll-distance="200"
					infinite-scroll-throttle-delay="200"
				>
					<v-menu :nudge-width="100">
						<template v-slot:activator="{ on }">
							<v-toolbar-title v-on="on">
								<span class="ml-3">{{ selectedSport }}</span>
								<v-icon>arrow_drop_down</v-icon>
							</v-toolbar-title>
						</template>
						<v-list>
							<v-list-tile
								v-for="sport in Object.keys(allSportsIds)"
								:key="sport"
								@click="() => changeSport(sport)"
							>
								<v-list-tile-title
									v-text="sport"
								></v-list-tile-title>
							</v-list-tile>
						</v-list>
					</v-menu>
					<v-card
						v-for="(item, i) in matchHistory.completedMatches"
						:key="i"
						class="card-item"
					>
						<div class="d-flex justify-space-between">
							<div>
								<div class="caption theme-text">
									{{
										new Date(
											item.matchStartTime
										).toDateString()
									}}
								</div>
								<div
									class="caption blue-grey--text text--lighten-1"
								>
									{{
										tournamentsData[item.tournamentId]
											.tournamentName || ""
									}}
								</div>
								<div class="d-flex align-center pt-1">
									<img
										:src="teamsData[item.team1].imageUrl"
										:alt="teamsData[item.team1].teamName"
										height="16px"
										style="max-width:fit-content;"
									/>
									<span class="pl-2">{{
										teamsData[item.team1].teamName
									}}</span>
								</div>
								<div class="d-flex align-center pt-1">
									<img
										:src="teamsData[item.team2].imageUrl"
										:alt="teamsData[item.team2].teamName"
										height="16px"
										style="max-width:fit-content;"
									/>
									<span class="pl-2">{{
										teamsData[item.team2].teamName
									}}</span>
								</div>
							</div>
							<div>
								<div
									class="caption blue-grey--text text--lighten-1 d-flex justify-end"
								>
									Total Winnings
								</div>
								<div
									class="body-2 theme-text d-flex justify-end"
									style="font-weight: 700;"
								>
									{{ item.amountWon.toFixed(2) }}
								</div>
								<div
									class="caption blue-grey--text text--lighten-1 d-flex justify-end pt-2"
								>
									Contest Joined
								</div>
								<div
									class="caption theme-text d-flex justify-end pr-1"
									style="font-weight: 600;"
								>
									{{ item.totalContestsJoined }}
								</div>
							</div>
						</div>
					</v-card>
				</v-card>
			</v-tab-item>
			<v-tab-item :value="tabs[1]">
				<v-card
					color="#EDF0F7"
					class="bg"
					v-infinite-scroll="fetchRechargeHistory"
					infinite-scroll-disabled="disableRechargeHistoryFetching"
					infinite-scroll-distance="200"
					infinite-scroll-throttle-delay="200"
				>
					<v-card
						v-for="(item, i) in rechargeHistory.list"
						:key="i"
						class="card-item"
					>
						<div class="d-flex justify-space-between">
							<div>
								<div class="title theme-text pb-2">
									{{ item.title || "-" }}
								</div>
								<div
									class="caption blue-grey--text text--lighten-1"
								>
									{{ item.subtitle }}
								</div>
							</div>
							<div>
								<div
									class="d-flex justify-end title pb-2"
									:class="
										item.amount > 0
											? `light-blue--text text--darken-4`
											: `blue-grey--text text--lighten-1`
									"
								>
									{{ item.amount > 0 ? "+ ₹" : "- ₹" }}
									{{ Math.abs(item.amount).toLocaleString() }}
								</div>
								<div
									class="caption blue-grey--text text--lighten-1 d-flex justify-end"
								>
									{{
										new Date(item.createdOn).toDateString()
									}}
								</div>
							</div>
						</div>
					</v-card>
				</v-card>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>
<script>
import {
	FETCH_USER_MATCH_HISTORY,
	FETCH_USER_RECHARGE_HISTORY
} from "../../store/action-types";
import { mapState } from "vuex";
import infiniteScroll from "vue-infinite-scroll";
import { END, TOP } from "../../store/config";
import { ALL_SPORTS } from "../../../config";

export default {
	data() {
		return {
			selectedTab: "Matches",
			tabs: ["Matches", "Recharges"],
			allSportsIds: [...ALL_SPORTS].reduce(
				(obj, sport) => ({ ...obj, [sport.name]: sport.id }),
				{}
			),
			selectedSport: "Cricket",
			disableRechargeHistoryFetching: true,
			disableMatchHistoryFetching: false
		};
	},
	directives: { infiniteScroll },
	methods: {
		fetchRechargeHistory(type = END) {
			if (!this.disableRechargeHistoryFetching) {
				this.disableRechargeHistoryFetching = true;
				this.$store
					.dispatch(FETCH_USER_RECHARGE_HISTORY.dispatch, {
						userId: this.$route.query.id,
						type
					})
					.catch(() => {})
					.then(() => {
						this.disableRechargeHistoryFetching = !this
							.rechargeHistory.offset;
					});
			}
		},
		fetchMatchHistory(type = END) {
			if (!this.disableMatchHistoryFetching || type === TOP) {
				this.disableMatchHistoryFetching = true;
				this.$store
					.dispatch(FETCH_USER_MATCH_HISTORY.dispatch, {
						userId: this.$route.query.id,
						sportId: this.allSportsIds[this.selectedSport],
						type
					})
					.catch(() => {})
					.then(() => {
						this.disableMatchHistoryFetching = !this.matchHistory
							.offset;
					});
			}
		},
		changeSport(sport) {
			this.selectedSport = sport;
			this.fetchMatchHistory(TOP);
		}
	},
	mounted() {
		this.fetchMatchHistory(TOP);
	},
	computed: {
		...mapState({
			rechargeHistory: state => state.jeet11.userHistory.recharges,
			matchHistory: state => state.jeet11.userHistory.matches,
			tournamentsData: state =>
				state.jeet11.userHistory.matches.tournamentsData || {},
			teamsData: state => state.jeet11.userHistory.matches.teamsData || {}
		})
	},
	watch: {
		selectedTab(newVal) {
			if (newVal === this.tabs[0]) {
				this.disableRechargeHistoryFetching = true;
				this.disableMatchHistoryFetching = false;
				this.fetchMatchHistory(TOP);
			} else if (newVal === this.tabs[1]) {
				this.disableMatchHistoryFetching = true;
				this.disableRechargeHistoryFetching = false;
				this.fetchRechargeHistory(TOP);
			}
		}
	}
};
</script>
<style scoped>
.bg {
	padding: 0.5em 1em 1em 1em;
	border-radius: 12px;
}
.card-item {
	background: #ffffff;
	box-shadow: 0px 2px 8px rgba(0, 49, 176, 0.05);
	border-radius: 12px;
	padding: 12px 16px;
	margin: 12px 4px;
}
</style>
